<section class="contact-top">
    <div class="container">
        <div class="row">
            <div class="inner_sec">
                <h2>Plastic Parts Processing.</h2>
                 
            <div class="tabbing_sec">
                <mat-tab-group>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <lucide-icon name="hammer" class="icon"></lucide-icon>
                        Capabilities
                      </ng-template>
                      
                      <div class="product_list">
                         <h3>Material Expertise</h3>
                         <ul class="top_list">
                            <li *ngFor="let data of materialExpertise"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>

                        <h3>Size & Precision</h3>
                         <ul class="top_list">
                            <li *ngFor="let data of sizeandprecision"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>

                        <h3>Advanced Moulding Techniquess</h3>
                        <ul class="top_list">
                            <li *ngFor="let data of advancemouldingtechnique"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>

                        <h3>In-House Technology</h3>
                        <ul class="top_list">
                            <li *ngFor="let data of inhousetech"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>
                        
                        <div class="product_box capability">
                            <h3>Advanced Moulding Techniques</h3>
                            <div class="row">   
                                <div class="col-sm-4" *ngFor="let data of advanceMoullding">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                      </div>

                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <lucide-icon name="PackageOpen" class="icon"></lucide-icon>
                        Products
                      </ng-template>
                      <div class="product_list">
                        <div class="product_box product">
                            <h3>Plastic Parts</h3>
                            <div class="row">   
                                <div class="col-sm-4" *ngFor="let data of produtData">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="product_box">
                            <h3>Products</h3>
                            <div class="row">
                                <div class="col-sm-4" *ngFor="let data of produtData">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                  
            </div>

            </div>

        </div>
        
    </div>
</section>

